// extracted by mini-css-extract-plugin
export default {"formContents":"create_formContents__N9hWN"};